import { InputHTMLAttributes } from 'react';

import { PropsWithClassName } from '~types/Props.types';

export enum FormInputMods {
  Lg = 'lg',
  Xs = 'xs',
}

type InputAttrs = Pick<
  InputHTMLAttributes<HTMLInputElement>,
  | 'id'
  | 'name'
  | 'placeholder'
  | 'value'
  | 'readOnly'
  | 'required'
  | 'disabled'
  | 'type'
  | 'onChange'
  | 'onFocus'
  | 'onBlur'
>;

export type FormInputProps = InputAttrs &
  PropsWithClassName<{
    isError?: boolean;
    label?: string;
    mods?: FormInputMods[];
  }> & {
    mask?: string;
  };
